module.exports = __webpack_public_path__ + "95e3cbc73ed67ea2fe0579bb114197ca.pdf";